import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom'
import { List, ListItem, ListItemText } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  btnActiveMenu : {
    borderLeft: "3px solid #000",
    paddingLeft: "10px", 
    marginLeft: "20px"
  },
  btnNonActiveMenu : {
    borderLeft: "3px solid #E8E8E8",
    paddingLeft: "10px", 
    marginLeft: "20px"
  }
}));
const FeatureList = ({ appId }) => {
  const classes = useStyles();
  const history = useHistory()
  const [active, setActive] = useState()
  
  const handleSocialLogin = () => {
    history.push(`/app/${appId}/socialLogin`)
  }

  const handleOtpLogin = () => {
    history.push(`/app/${appId}/otpLogin`)
  }

  const handleReport = () => {
    history.push(`/app/${appId}/Report`)
  }

  return (
    <List>
      <ListItem button onClick={handleSocialLogin} className={classes.btnNonActiveMenu}>
        <span className="font-size-14">Social Media Login</span>
      </ListItem>
      <ListItem button onClick={handleOtpLogin} className={classes.btnNonActiveMenu}>
        <span className="font-size-14">One Time Password Login</span>
      </ListItem>
      <ListItem button onClick={handleReport} className={classes.btnNonActiveMenu}>
        <span className="font-size-14">Report</span>
      </ListItem>
    </List>
  );
}

export default FeatureList;